import React, { Component } from 'react';

class FileUploadActions extends Component {
    render() {
        const {file, onToggleModal, onRemoveFile, label} = this.props;
        if(file) {
            return(
                <div style={{height: '30px'}}>
                    <div style={{
                        float: 'left',
                        transform: 'translateY(-50%)',
                        top: '50%',
                        position: 'relative',
                    }}><i>{file.name ? file.name : file}</i></div>
                    {onRemoveFile && <button type="button" className="icon" onClick={onRemoveFile} style={{float: 'left'}}><img src="/images/assets/kryds.svg" alt="fjern" /></button>}
                    <div style={{clear: 'both'}}/>
                </div>
            );
        } else {
            return(
                    <button type="button" className="button button--small" onClick={() => onToggleModal()}>{label ? label : 'Upload'}</button>
            );
        }
    }
}

export default FileUploadActions;


// WEBPACK FOOTER //
// ./src/modules/admin/organization/sections/FileUploadActions.js